'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ObjectField2 = require('react-jsonschema-form/lib/components/fields/ObjectField');

var _ObjectField3 = _interopRequireDefault(_ObjectField2);

var _utils = require('react-jsonschema-form/lib/utils');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LayoutGridField = function (_ObjectField) {
  _inherits(LayoutGridField, _ObjectField);

  function LayoutGridField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LayoutGridField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LayoutGridField.__proto__ || Object.getPrototypeOf(LayoutGridField)).call.apply(_ref, [this].concat(args))), _this), _this.state = { firstName: 'hasldf' }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LayoutGridField, [{
    key: 'render',
    value: function render() {
      var uiSchema = this.props.uiSchema;
      var layoutGridSchema = this.props.layoutGridSchema;

      if (!layoutGridSchema) layoutGridSchema = uiSchema['ui:layout_grid'];

      if (layoutGridSchema['ui:row']) {
        return this.renderRow(layoutGridSchema);
      } else if (layoutGridSchema['ui:col']) {
        return this.renderCol(layoutGridSchema);
      } else {
        return this.renderField(layoutGridSchema);
      }
    }
  }, {
    key: 'renderRow',
    value: function renderRow(layoutGridSchema) {
      var key = this.props.key;

      var rows = layoutGridSchema['ui:row'];

      var group = layoutGridSchema['ui:group'];

      if (group) {
        var _props$registry = this.props.registry,
            fields = _props$registry.fields,
            formContext = _props$registry.formContext;
        var TitleField = fields.TitleField;
        var required = this.props.required;

        var title = group && typeof group === 'string' ? group : null;

        return _react2.default.createElement(
          'fieldset',
          { className: 'rjsf-layout-grid-group' },
          title ? _react2.default.createElement(TitleField, {
            title: title,
            required: required,
            formContext: formContext }) : null,
          _react2.default.createElement(
            'div',
            { className: 'row', key: key },
            this.renderChildren(rows)
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'row', key: key },
          this.renderChildren(rows)
        );
      }
    }
  }, {
    key: 'renderCol',
    value: function renderCol(layoutGridSchema) {
      var key = this.props.key;

      var _layoutGridSchema$ui = layoutGridSchema['ui:col'],
          children = _layoutGridSchema$ui.children,
          colProps = _objectWithoutProperties(_layoutGridSchema$ui, ['children']);

      var group = layoutGridSchema['ui:group'];

      if (group) {
        var _props$registry2 = this.props.registry,
            fields = _props$registry2.fields,
            formContext = _props$registry2.formContext;
        var TitleField = fields.TitleField;
        var required = this.props.required;

        var title = group && typeof group === 'string' ? group : null;

        return _react2.default.createElement(
          _reactBootstrap.Col,
          _extends({}, colProps, { key: key }),
          _react2.default.createElement(
            'fieldset',
            { className: 'rjsf-layout-grid-group' },
            title ? _react2.default.createElement(TitleField, {
              title: title,
              required: required,
              formContext: formContext }) : null,
            this.renderChildren(children)
          )
        );
      } else {
        return _react2.default.createElement(
          _reactBootstrap.Col,
          _extends({}, colProps, { key: key }),
          this.renderChildren(children)
        );
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren(childrenLayoutGridSchema) {
      var _this2 = this;

      var definitions = this.props.registry.definitions;

      var schema = (0, _utils.retrieveSchema)(this.props.schema, definitions);

      return childrenLayoutGridSchema.map(function (layoutGridSchema, index) {
        return _react2.default.createElement(LayoutGridField, _extends({}, _this2.props, {
          key: index,
          schema: schema,
          layoutGridSchema: layoutGridSchema }));
      });
    }
  }, {
    key: 'renderField',
    value: function renderField(layoutGridSchema) {
      var _props = this.props,
          key = _props.key,
          uiSchema = _props.uiSchema,
          errorSchema = _props.errorSchema,
          idSchema = _props.idSchema,
          disabled = _props.disabled,
          readonly = _props.readonly,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          formData = _props.formData;
      var _props$registry3 = this.props.registry,
          definitions = _props$registry3.definitions,
          fields = _props$registry3.fields;
      var SchemaField = fields.SchemaField;

      var schema = (0, _utils.retrieveSchema)(this.props.schema, definitions);
      var name = void 0;
      var render = void 0;
      if (typeof layoutGridSchema === 'string') {
        name = layoutGridSchema;
      } else {
        name = layoutGridSchema.name;
        render = layoutGridSchema.render;
      }

      if (schema.properties[name]) {
        return _react2.default.createElement(SchemaField, {
          key: key,
          name: name,
          required: this.isRequired(name),
          schema: schema.properties[name],
          uiSchema: uiSchema[name],
          errorSchema: errorSchema[name],
          idSchema: idSchema[name],
          formData: formData[name],
          onChange: this.onPropertyChange(name),
          onBlur: onBlur,
          onFocus: onFocus,
          registry: this.props.registry,
          disabled: disabled,
          readonly: readonly });
      } else {
        var UIComponent = render || function () {
          return null;
        };

        return _react2.default.createElement(UIComponent, {
          key: key,
          name: name,
          formData: formData,
          errorSchema: errorSchema,
          uiSchema: uiSchema,
          schema: schema,
          registry: this.props.registry
        });
      }
    }
  }]);

  return LayoutGridField;
}(_ObjectField3.default);

exports.default = LayoutGridField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsonschema-form-layout-grid/es/index.js
// module id = 1773
// module chunks = 0